import { TaskType } from '@shared/enums/task-type.enum';
import { TaskSidenavController } from '@shared/modules/task-sidenav/controllers/task-sidenav.controller';
import { AfterViewInit, Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { DEFAULT_PANEL_ROLES } from '@shared/auth/enums/app-role.enum';
import { SidenavService } from '@shared/services/sidenav/sidenav.service';
import { BaseNavigationComponent } from '@shared/modules/base-panel/components/base-navigation.component';
import { NavigateService } from '@shared/services/navigate.service';
import { publicFile } from '@shared/helpers/public-file.helper';
import { StorageService } from '@core/services/storage.service';
import { ContactController } from '@modules/contacts/shared/controllers/contact.controller';
import { ProjectController } from '@modules/projects/shared/controllers/project.controller';
import { ButtonSize, ButtonTypes } from '@shared/modules/ui/components/button/button.component';
import { debounce } from '@shared/decorators/debounce.decorator';
import { ChangesSidenavController } from '@shared/modules/task-sidenav/controllers/changes-sidenav.controller';
import { EventSidenavController } from '@shared/modules/event-sidenav/controllers/event-sidenav.controller';

@Component({
  selector: 'mobile-navigation',
  templateUrl: './mobile-navigation.component.html',
  styleUrls: ['./mobile-navigation.component.scss']
})
export class MobileNavigationComponent extends BaseNavigationComponent implements OnInit, AfterViewInit {
  ButtonTypes = ButtonTypes;
  TaskType = TaskType;
  ButtonSize = ButtonSize;
  protected readonly defaultPanelRoles = DEFAULT_PANEL_ROLES;

  imageUrl: string;

  static readonly componentName: string = 'MobileNavigationComponent';

  @ViewChild('mobileNavigation') mobileNavigation: ElementRef;

  public readonly sidenavService = inject(SidenavService);
  public readonly n = inject(NavigateService);
  public override readonly store = inject(StorageService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.setImageUrl();
  }

  ngAfterViewInit() {
    this.setHeightToNavigation();
  }

  setHeightToNavigation() {
    let clientHeight = document.documentElement.clientHeight;
    this.mobileNavigation.nativeElement.style.height = clientHeight + 'px';
  }

  closeMenu() {
    this.sidenavService.close();
  }

  setImageUrl() {
    const userPerson = this.store.UserPerson;
    userPerson.photo ? (this.imageUrl = publicFile(userPerson.photo, 100)) : null;
  }

  createContact() {
    const ctrl = new ContactController();
    ctrl.add();
    this.sidenavService.close();
  }

  createProjectDraft() {
    const ctrl = new ProjectController();
    ctrl.add().add(() => {
      this.sidenavService.close();
    });
  }

  createTask(type: TaskType = TaskType.TYPE_TASK) {
    const ctrl = new TaskSidenavController();
    ctrl.addTask({ taskType: type });
    this.sidenavService.close();
  }

  createChange() {
    const ctrl = new ChangesSidenavController();
    ctrl.addChange(null);
    this.sidenavService.close();
  }

  createEvent() {
    const ctrl = new EventSidenavController();
    ctrl.createEvent();
  }

  @HostListener('window:resize', ['$event'])
  @debounce(50)
  windowResize(e: KeyboardEvent) {
    this.setHeightToNavigation();
    this.closeMenu();
  }
}
